import { useState, useEffect, useLayoutEffect } from "react";

const useScreenSize = () => {
  const [isMobile, setIsMobile] = useState<boolean | null>(null);

  // Use layout effect to reduce flicker before paint
  const useIsomorphicLayoutEffect =
    typeof window !== "undefined" ? useLayoutEffect : useEffect;

  useIsomorphicLayoutEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  return { isMobile };
};

export default useScreenSize;
